import { verifyRequiredBetaFeatures } from 'utils/betaFeatures/verifyRequiredBetaFeatures';
import { filterQueryParametersAndReplace } from 'utils/url';

import {
  OR_MANAGEMENT_BETA_FEATURES,
} from './const';

export default [
  {
    path: 'orHome(.do)(.go)',
    onEnterHandlers: [
      filterQueryParametersAndReplace('/or-signup'),
    ],
  },
  {
    path: 'displaySlotSubSetting(.do)(.go)',
    onEnterHandlers: [
      verifyRequiredBetaFeatures(OR_MANAGEMENT_BETA_FEATURES),
      filterQueryParametersAndReplace('/or-management'),
    ],
  },
];
